(function () {
  var PINNED_HANDLES = [
    'holy-grail-hyaluronic-acid-moisturizing-cream',
    'holy-grail-hyaluronic-acid-hydrating-serum-1'
  ];

  function getImageUrl(product) {
    if (product.images && product.images[0]) return product.images[0].src || product.images[0];
    if (product.featured_image) {
      if (typeof product.featured_image === 'string') return product.featured_image;
      if (product.featured_image.url) return product.featured_image.url;
    }
    return '';
  }

  function getPrice(product) {
    var price = product.price_min != null ? product.price_min
      : product.price != null ? product.price
      : product.variants && product.variants[0] ? product.variants[0].price
      : null;
    if (price == null || price === '') return '';
    var amount = typeof price === 'number' ? price / 100 : parseFloat(price);
    if (isNaN(amount)) return String(price);
    var fmt = window.Shopify && window.Shopify.money_format;
    if (fmt) {
      return fmt
        .replace('{{amount}}', amount.toFixed(2))
        .replace('{{amount_with_comma_separator}}', amount.toFixed(2).replace('.', ','))
        .replace('{{amount_no_decimals}}', Math.round(amount));
    }
    return 'EGP ' + Math.round(amount);
  }

  function getVariantId(product) {
    return product.variants && product.variants[0] ? product.variants[0].id : null;
  }

  async function fetchCartIds() {
    try {
      var res = await fetch('/cart.js');
      var data = await res.json();
      return new Set((data.items || []).map(function (i) { return i.product_id; }));
    } catch (e) { return new Set(); }
  }

  async function getProducts() {
    var cartIds = await fetchCartIds();
    var results = [];

    for (var i = 0; i < PINNED_HANDLES.length; i++) {
      try {
        var res = await fetch('/products/' + PINNED_HANDLES[i] + '.json');
        var data = await res.json();
        var p = data.product;
        if (p && p.variants && p.variants.length === 1 && p.variants[0].available && !cartIds.has(p.id)) results.push(p);
      } catch (e) {}
    }

    if (results.length < 2) {
      var pinnedIds = new Set(results.map(function (p) { return p.id; }));
      try {
        var fallRes = await fetch('/collections/all/products.json?limit=20');
        var fallData = await fallRes.json();
        var fallbacks = (fallData.products || []).filter(function (p) {
          return p.variants && p.variants.length === 1 && p.variants[0].available && !cartIds.has(p.id) && !pinnedIds.has(p.id) && PINNED_HANDLES.indexOf(p.handle) === -1;
        });
        for (var j = 0; j < fallbacks.length && results.length < 2; j++) results.push(fallbacks[j]);
      } catch (e) {}
    }

    return results;
  }

  async function addToCart(variantId, btn) {
    btn.disabled = true;
    btn.textContent = 'Adding...';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      btn.textContent = 'Added ✓';
      setTimeout(function () { window.location.reload(); }, 800);
    } catch (e) {
      btn.disabled = false;
      btn.textContent = 'Add';
    }
  }

  function renderCard(product) {
    var card = document.createElement('div');
    card.className = 'piw-card';
    var img = getImageUrl(product);
    var price = getPrice(product);
    var variantId = getVariantId(product);
    var url = product.url || ('/products/' + product.handle);

    card.innerHTML =
      '<a href="' + url + '" class="piw-card__img-wrap">' +
        (img ? '<img src="' + img + '" alt="' + (product.title || '') + '" loading="lazy">' : '') +
      '</a>' +
      '<div class="piw-card__body">' +
        '<a href="' + url + '" class="piw-card__name">' + (product.title || '') + '</a>' +
        '<p class="piw-card__price">' + price + '</p>' +
        (variantId ? '<button class="piw-card__btn">Add to cart</button>' : '') +
      '</div>';

    if (variantId) {
      card.querySelector('.piw-card__btn').addEventListener('click', function () {
        addToCart(variantId, this);
      });
    }
    return card;
  }

  function closePopup() {
    var popup = document.getElementById('piw-popup');
    if (!popup) return;
    popup.style.opacity = '0';
    popup.style.transform = 'translateY(16px)';
    setTimeout(function () {
      popup.classList.remove('is-open');
      popup.style.opacity = '';
      popup.style.transform = '';
    }, 500);
  }

  function openPopup(products) {
    var popup = document.getElementById('piw-popup');
    var cardsEl = document.getElementById('piw-cards');
    var closeBtn = document.getElementById('piw-close');
    if (!popup || !cardsEl) return;

    cardsEl.innerHTML = '';
    products.forEach(function (p) { cardsEl.appendChild(renderCard(p)); });

    popup.classList.add('is-open');
    closeBtn && closeBtn.addEventListener('click', closePopup);
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { closePopup(); document.removeEventListener('keydown', onKey); }
    });
  }

  async function init() {
    if (window.location.pathname !== '/cart') return;
    var products = await getProducts();
    if (!products.length) return;
    setTimeout(function () { openPopup(products); }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
